import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToSectionWithRetry } from "../utils/navigation";

const HashScroll = ({ enabled = true }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!enabled || pathname !== "/" || !hash) return;

    const scrollKey = `returnScrollY:${hash}`;
    const savedScrollY = window.sessionStorage.getItem(scrollKey);

    if (savedScrollY !== null) {
      window.sessionStorage.removeItem(scrollKey);
      const targetScrollY = Number(savedScrollY);

      if (Number.isFinite(targetScrollY)) {
        window.setTimeout(() => {
          window.scrollTo({ top: targetScrollY, behavior: "auto" });
        }, 0);
        return;
      }
    }

    scrollToSectionWithRetry(hash, { behavior: "auto" });
  }, [enabled, pathname, hash]);

  return null;
};

export default HashScroll;
